export default "__VITE_ASSET__BffvK2of__"